import { render, staticRenderFns } from "./MapDot.vue?vue&type=template&id=39841af0&scoped=true&"
import script from "./MapDot.vue?vue&type=script&lang=ts&"
export * from "./MapDot.vue?vue&type=script&lang=ts&"
import style0 from "./MapDot.vue?vue&type=style&index=0&id=39841af0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39841af0",
  null
  
)

export default component.exports